// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Accounting from "@wino/accounting/src/Accounting.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  wrapper: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    $$css: "wino-gc:src/modules/Cart/CartProductQuantityTableCell.res.js:16"
  }
};
function CartProductQuantityTableCell(props) {
  let dispatch = props.onRequestDispatch;
  let __beforeOrderReception = props.beforeOrderReception;
  let __editable = props.editable;
  let product = props.product;
  let editable = __editable !== undefined ? __editable : false;
  let beforeOrderReception = __beforeOrderReception !== undefined ? __beforeOrderReception : true;
  let match;
  if (product.TAG === "Unit") {
    let product$1 = product._0;
    match = [product$1.id, Stdlib_Option.map(product$1.packaging, prim => prim), product$1.quantity, product$1.expectedQuantity, product$1.expectedQuantityWarning];
  } else {
    let product$2 = product._0;
    match = [product$2.id, Stdlib_Option.map(product$2.packaging, prim => prim.toNumber()), product$2.quantity.toNumber(), product$2.expectedQuantity.toNumber(), product$2.expectedQuantityWarning];
  }
  let expectedQuantity = match[3];
  let quantity = match[2];
  let packaging = match[1];
  let productId = match[0];
  let bulk;
  if (product.TAG === "Unit") {
    bulk = undefined;
  } else {
    let unit = product._0.capacityUnit;
    bulk = unit !== undefined ? [unit, product._1] : undefined;
  }
  let onChange = React.useCallback(value => {
    let quantity = Accounting.isBulk(product) ? {
      TAG: "BulkQuantity",
      _0: value
    } : {
      TAG: "UnitQuantity",
      _0: value | 0
    };
    if (beforeOrderReception) {
      return dispatch({
        TAG: "ProductExpectedQuantityUpdated",
        _0: productId,
        _1: quantity
      });
    } else {
      return dispatch({
        TAG: "ProductQuantityUpdated",
        _0: productId,
        _1: quantity
      });
    }
  }, [productId]);
  let inputPrecision = bulk !== undefined ? bulk[1] : 0;
  let inputAppender;
  if (bulk !== undefined) {
    let unit$1 = bulk[0];
    inputAppender = beforeOrderReception ? {
      TAG: "Custom",
      _0: ` ` + unit$1
    } : {
      TAG: "Custom",
      _0: `/ ` + expectedQuantity.toString() + ` ` + unit$1
    };
  } else {
    inputAppender = beforeOrderReception ? undefined : {
      TAG: "Custom",
      _0: `/ ` + expectedQuantity.toString()
    };
  }
  let formattedQuantity = quantity.toString().replace(".", ",") + Stdlib_Option.mapOr(bulk, "", param => ` ` + param[0]);
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5",
      "data-style-src": "wino-gc:src/modules/Cart/CartProductQuantityTableCell.res.js:16"
    }
  };
  let tmp;
  if (editable) {
    let tmp$1;
    if (packaging !== undefined && match[4].length !== 0) {
      let formattedPackagingBy = I18n.template(I18n.t("Packaging by {{packaging}}"), {
        packaging: packaging
      }, undefined);
      tmp$1 = JsxRuntime.jsx(TooltipIcon.make, {
        children: JsxRuntime.jsx(Tooltip.Span.make, {
          text: formattedPackagingBy
        }),
        variation: "info"
      }, productId);
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: quantity,
          minValue: 0,
          precision: inputPrecision,
          appender: inputAppender,
          shrinkInput: true,
          onChange: onChange
        }),
        spaceRight: "xnormal"
      }), tmp$1]
    });
  } else {
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: formattedQuantity,
      weight: "semibold"
    });
  }
  newrecord.children = tmp;
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(CartProductQuantityTableCell, (oldProps, newProps) => {
  if (oldProps.product === newProps.product && oldProps.editable === newProps.editable) {
    return oldProps.beforeOrderReception === newProps.beforeOrderReception;
  } else {
    return false;
  }
});
export { styles, make };
/* styles Not a pure module */